export default {
  addFileNamesAboveEachImage: 'Добавить имена файлов над каждым изображением',
  comments: 'Комментарии',
  couldNotLoadWhiteboard: 'Не удалось загрузить доску. Попробуйте ещё раз.',
  filterComments: 'Фильтр комментариев',
  goToWhiteboardAfterSending: 'Перейти на доску после отправки',
  inProgress: 'В работе',
  limits: 'Лимиты',
  markAsUnresolved: 'Отметить как нерешённое',
  pagesOnThisWhiteboard: 'Страницы на этой доске',
  resolved: 'Решённые',
  saveDraft: 'Сохранить черновик',
  setInProgress: 'Перевести в работу',
  shapesOnThisPage: 'Фигуры на этой странице',
  showInProgressComments: 'Показывать в работе',
  showResolvedComments: 'Показывать решённые',
  unsetInProgress: 'Убрать из работы',
  whiteboardRoomFull:
    'Достигнут лимит подключений к этой доске. Закройте лишние вкладки с этой доской и попробуйте ещё раз.',
  youHaveUsedAllPagesQuota: 'Вы использовали все доступные страницы.',
  youHaveUsedAllShapesQuota: 'Вы использовали все фигуры на этой странице.'
};
